import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const ChevronRight = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M12.4088 11.9996L8.6044 8.1954c-.2112-.2114-.3168-.4766-.3168-.7958 0-.3192.1056-.5844.3168-.7957.2113-.2112.4765-.3168.7957-.3168s.5844.1056.7957.3168l4.594 4.594c.1119.112.1936.2363.2453.373.0517.1365.0775.2794.0775.4287 0 .1493-.0258.2923-.0775.4288-.0517.1366-.1334.261-.2453.373l-4.594 4.594c-.2113.2111-.4765.3167-.7957.3167s-.5844-.1056-.7957-.3167c-.2112-.2114-.3168-.4766-.3168-.7958 0-.3192.1056-.5844.3168-.7957l3.8044-3.8043z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M10.9913 11.9996l3.8045-3.8042c.2112-.2114.3168-.4766.3168-.7958 0-.3192-.1056-.5844-.3168-.7957-.2113-.2112-.4765-.3168-.7957-.3168s-.5844.1056-.7958.3168l-4.594 4.594c-.1118.112-.1935.2363-.2452.373a1.2008 1.2008 0 00-.0775.4287c0 .1493.0258.2923.0775.4288.0517.1366.1334.261.2453.373l4.5939 4.594c.2114.2111.4766.3167.7958.3167.3192 0 .5844-.1056.7957-.3167.2112-.2114.3168-.4766.3168-.7958 0-.3192-.1056-.5844-.3168-.7957l-3.8045-3.8043z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M12.4088 11.9996L8.6044 8.1954c-.2112-.2114-.3168-.4766-.3168-.7958 0-.3192.1056-.5844.3168-.7957.2113-.2112.4765-.3168.7957-.3168s.5844.1056.7957.3168l4.594 4.594c.1119.112.1936.2363.2453.373.0517.1365.0775.2794.0775.4287 0 .1493-.0258.2923-.0775.4288-.0517.1366-.1334.261-.2453.373l-4.594 4.594c-.2113.2111-.4765.3167-.7957.3167s-.5844-.1056-.7957-.3167c-.2112-.2114-.3168-.4766-.3168-.7958 0-.3192.1056-.5844.3168-.7957l3.8044-3.8043z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M10.9913 11.9996l3.8045-3.8042c.2112-.2114.3168-.4766.3168-.7958 0-.3192-.1056-.5844-.3168-.7957-.2113-.2112-.4765-.3168-.7957-.3168s-.5844.1056-.7958.3168l-4.594 4.594c-.1118.112-.1935.2363-.2452.373a1.2008 1.2008 0 00-.0775.4287c0 .1493.0258.2923.0775.4288.0517.1366.1334.261.2453.373l4.5939 4.594c.2114.2111.4766.3167.7958.3167.3192 0 .5844-.1056.7957-.3167.2112-.2114.3168-.4766.3168-.7958 0-.3192-.1056-.5844-.3168-.7957l-3.8045-3.8043z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
ChevronRight.displayName = "ChevronRightIcon";

export { ChevronRight, ChevronRight as default };
